import { render, staticRenderFns } from "./CapabilityIcon.vue?vue&type=template&id=64dcd7b6&scoped=true&"
import script from "./CapabilityIcon.vue?vue&type=script&lang=ts&"
export * from "./CapabilityIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CapabilityIcon.vue?vue&type=style&index=0&id=64dcd7b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dcd7b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
